import Input from "../../../Components/Input";
import Radio from "../../../Components/Radio";

const GroupModal = ({ register, errors }) => {
	return (
		<>
			<div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Group Name <span className="text-red-500">*</span>
				</label>
				<Input
					id="name"
					placeholder="Input Group Name"
					required
					type="text"
					{...register("name")}
					errors={errors?.name?.message}
				/>
			</div>

			<div className="mb-5">
				<label htmlFor="status" className="block mb-3">
					Status <span className="text-red-500">*</span>
				</label>

				<div className="flex">
					<Radio id="status" label="Active" value="1" name="status" required {...register("status")} />
					<Radio id="status-2" label="Non Active" value="0" name="status" required {...register("status")} />
				</div>

				<small className="text-[red]">{errors.status?.message}</small>
			</div>
		</>
	);
};

export default GroupModal;
